"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import app components
const colors_1 = __importDefault(require("./colors"));
const breakpoints_1 = __importDefault(require("./breakpoints"));
const fontType = "sans-serif";
const typographyBasics = {
    fontFamily: `'Lato', 'Arial', 'Tahoma', '${fontType}'`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 900,
};
const typography = {
    fontFamily: typographyBasics.fontFamily,
    h1: {
        fontSize: "1.8rem",
        fontWeight: typographyBasics.fontWeightLight,
        color: colors_1.default.text[100],
        [breakpoints_1.default.up("md")]: {
            fontSize: "3rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "3.5rem",
        },
    },
    h2: {
        fontSize: "1.4rem",
        fontWeight: typographyBasics.fontWeightLight,
        color: colors_1.default.text[100],
        [breakpoints_1.default.up("md")]: {
            fontSize: "2rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "2.5rem",
        },
    },
    h3: {
        fontSize: "1.4rem",
        fontWeight: typographyBasics.fontWeightLight,
        color: colors_1.default.text[100],
        lineHeight: 1.2,
        [breakpoints_1.default.up("sm")]: {
            fontSize: "1.5rem",
        },
        [breakpoints_1.default.up("md")]: {
            fontSize: "1.6rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "2rem",
        },
    },
    h4: {
        fontSize: "1.1rem",
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[100],
        [breakpoints_1.default.up("sm")]: {
            fontSize: "1.2rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "1.5rem",
            lineHeight: 1.35,
        },
    },
    h5: {
        fontSize: "0.9rem",
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[100],
        [breakpoints_1.default.up("sm")]: {
            fontSize: "1rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "1.4rem",
        },
    },
    h6: {
        fontSize: "0.9rem",
        lineHeight: 1.5,
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[100],
        [breakpoints_1.default.up("xl")]: {
            fontSize: "1.03rem",
        },
    },
    body1: {
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[100],
    },
    body2: {
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[100],
    },
    subtitle1: {
        fontWeight: typographyBasics.fontWeightRegular,
        color: colors_1.default.text[700],
        letterSpacing: "0.3px",
        fontSize: "0.85rem",
        [breakpoints_1.default.up("xl")]: {
            fontSize: "1.03rem",
        },
    },
    subtitle2: {
        color: colors_1.default.primary[900],
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontWeight: 700,
        fontSize: "0.75rem",
    },
    caption: {
        fontSize: "0.6rem",
        fontWeight: 700,
        color: colors_1.default.text[100],
        lineHeight: 1,
        letterSpacing: "1px",
    },
    code: {
        fontFamily: "ui-monospace, SFMono-Regular, monospace",
        display: "inline-block",
    },
    nav: {
        fontSize: "0.48rem",
        textTransform: "uppercase",
        fontWeight: typographyBasics.fontWeightBold,
        color: colors_1.default.text[100],
        letterSpacing: "1px",
        lineHeight: "1rem",
        [breakpoints_1.default.up("sm")]: {
            fontSize: "0.5rem",
        },
        [breakpoints_1.default.up("xl")]: {
            fontSize: "0.58rem",
        },
    },
    button: {
        fontSize: "0.7rem",
        textTransform: "uppercase",
        fontWeight: typographyBasics.fontWeightBold,
        letterSpacing: "1px",
    },
};
exports.default = typography;
